export const getTemplateFromState = (data, id) => {
  const templateIndex = data.findIndex(template => template.get('id') === id)
  const template = data.get(templateIndex)

  return [template, templateIndex]
}
